import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { RequestHeaderConst } from '../../constant/information.const';
import { LegalDocument } from '../../constant/legal.const';
import { DataLoadURL } from '../../model/dataload-url';

import { ApiService } from '../api/api.service';
import { PartnerConfigService } from '../partner-config/partner-config.service';

export const Account_api = {
  GetPartnerConfigJson: {
    hostName: 'member-api',
    method: 'GET',
    url: 'Member/GetPartnerConfigJson'
  } as DataLoadURL
};

/**
 *
 * Service representing to
 * get the master details.
 * @export
 * @ class GlobalService
 */
@Injectable()
export class GlobalService implements OnDestroy {
  /** Return subscription */
  private readonly subscriptions: Subscription[] = [];
  /** blob string return */
  private blobString: string;
  /**
   * Creates an instance of GlobalService.
   * @paramapi api  - Consuming ApiService
   * @ memberof GlobalService
   */
  constructor(private readonly api: ApiService) {}
  public ngOnDestroy(): void {
    // tslint:disable-next-line: no-void-expression
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }

  /**
   * Get the partner config json list from server
   *
   * @ param {*} [callback]
   * @ memberof GlobalService
   */
  public getPartnerConfigJson(callback?: () => void): void {
    if (PartnerConfigService.getInstance().getPartners().length === 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const subs = this.api.request<any>({ urlObj: Account_api.GetPartnerConfigJson }).subscribe((response) => {
        if (response) {
          PartnerConfigService.getInstance().setPartners(response);
        }
        if (callback) {
          callback();
        }
      });
      this.subscriptions.push(subs);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public print(content: any, type: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = this.createBlobUrl(content, type);
    document.body.appendChild(iframe);
    setTimeout(() => {
      iframe.focus();
      iframe.contentWindow.print();
    }, 200);
  }

  public printPDF(url: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);
    setTimeout(() => {
      iframe.focus();
      iframe.contentWindow.print();
    }, 200);
  }

  // TODO: Remove this. We dont need this method, we can create tha <a> tag in the view and reference createBlobUrl()
  // If you are providing a download link, its likely the blob has already been created.
  public downloadFile(content, fileName, type): void {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = this.createBlobUrl(content, type);
    link.download = fileName;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    window.addEventListener('focus', (e) => URL.revokeObjectURL(link.href), { once: true });
  }

  // TODO: Remove this. We dont need this method, we can create tha <a> tag in the view
  public downloadFilePDF(content, fileName): void {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = content;
    link.download = fileName;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    window.addEventListener('focus', (e) => URL.revokeObjectURL(link.href), { once: true });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createBlobUrl(content: any, mimeType: string): string {
    const blob = new Blob([content], { type: mimeType });
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  }

  public downloadLegalDocument(value: string, mimeType?: string): Observable<Blob> {
    const temp_mimeType = !mimeType ? RequestHeaderConst.contentType : mimeType;
    return this.api.postImage({
      body: { value, mimeType: temp_mimeType },
      urlObj: LegalDocument.Get
    });
  }
}
